(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name utils.controller:UtilsCtrl
   *
   * @description
   *
   */
  angular
    .module('utils')
    .controller('UtilsCtrl', UtilsCtrl);

  UtilsCtrl.$inject = [];

  function UtilsCtrl() {
    var vm = this;
    vm.ctrlName = 'UtilsCtrl';
  }
}());
